import React, { useEffect, useRef } from 'react';

const GRLPortal = ({ entity, token, appenv = 'local', product = 'MLT' }) => {
  const portalRef = useRef(null);

  const savedEntity = localStorage.getItem('grl-entity');
  const savedToken = localStorage.getItem('grl-token');
  const savedAppenv = localStorage.getItem('grl-appenv');
  const savedProduct = localStorage.getItem('grl-product');

  useEffect(() => {
    // Load the required CSS for the GRL Customer Portal
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://assets.avalara.com/skylab-sdk/4.13.0/build/skylab-sdk.css';
    document.head.appendChild(link);

    // Load the required scripts
    const script1 = document.createElement('script');
    script1.src = 'https://joblistwc.qa.avalara.io';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'module';
    script2.src = 'https://assets.avalara.com/skylab-sdk/4.13.0/build/skylab-sdk.esm.js';
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.src = 'https://grl-ui.registrations-dev.avalara.net';
    document.head.appendChild(script3);

    // Cleanup function
    return () => {
      // Remove the added elements when component unmounts
      try {
        if (document.head.contains(link)) document.head.removeChild(link);
        if (document.head.contains(script1)) document.head.removeChild(script1);
        if (document.head.contains(script2)) document.head.removeChild(script2);
        if (document.head.contains(script3)) document.head.removeChild(script3);
      } catch (error) {
        console.warn('Error during cleanup:', error);
      }
    };
  }, []);

  return (
    <div ref={portalRef} className="grl-portal-container">
      <grl-customer-portal
        appenv={savedAppenv}
        entity={savedEntity}
        usemockdata="false"
        token={savedToken}
        product={savedProduct}
      />
    </div>
  );
};

export default GRLPortal; 